/**
 * @description
 * Objeto statisticsFiltro
 */

export class StatisticsFiltro {

    public users: string;
    public idnumber: string;
    public dateini: Date;
    public datefin: Date;

    constructor() {}
  
}